import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Chip from "@mui/material/Chip";
import Collapse from "@mui/material/Collapse";
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { CaretDown } from "@phosphor-icons/react/CaretDown";
import { CaretRight } from "@phosphor-icons/react/CaretRight";
import { Question } from "@phosphor-icons/react/Question";
import * as React from "react";

const faqs = [
	{
		id: "FAQ-1",
		question: "How’s the pricing work?",
		answer:
			"Fixed annual and multi-year plans—no surprises, perfect for county budgets.",
	},
	{
		id: "FAQ-2",
		question: "Do I need to self-host?",
		answer: "Nope—fully hosted, no servers or IT woes.",
	},
	{
		id: "FAQ-3",
		question: "Can I brand my maps?",
		answer: "Absolutely—custom logos, styles, and domains included.",
	},
	{
		id: "FAQ-4",
		question: "Will residents like it?",
		answer: "Simple, accurate maps keep end users satisfied.",
	},
	{
		id: "FAQ-5",
		question: "Does it fit procurement?",
		answer:
			"We know the procurement lifecycle, and can work with you from go to woah. Bank transfers and annual billing make it committee-friendly.",
	},
	{
		id: "FAQ-6",
		question: "Is it fast to set up?",
		answer: "From data to live map in hours, not weeks.",
	},
	{
		id: "FAQ-7",
		question: "Is it better than pricey GIS suites?",
		answer: "Cheaper, simpler, and tailored to small-town needs.",
	},
	{
		id: "FAQ-7",
		question: "What if I need help?",
		answer: "Your dedicated account manager is on hand to help you.",
	},
] satisfies { id: string; question: string; answer: string }[];

export function Faqs() {
	return (
		<Box sx={{ bgcolor: "var(--mui-palette-background-level1)", py: "120px" }}>
			<Container maxWidth="md">
				<Stack spacing={8}>
					<Stack
						maxWidth="700px"
						sx={{ mx: "auto" }}>
						<Stack spacing={2}>
							<Box sx={{ display: "flex", justifyContent: "center" }}>
								<Chip
									color="primary"
									icon={<Question />}
									label="FAQ"
									variant="soft"
								/>
							</Box>
							<Typography
								sx={{ textAlign: "center" }}
								variant="h3">
								Need more answers?
							</Typography>
							<Typography color="text.secondary">
								Check our&nbsp;
								<Box
									component="a"
									href="https://help.mangomap.com/hc/en-us/sections/360007615811-Frequently-Asked-Questions"
									sx={{ color: "inherit", textDecoration: "underline" }}>
									complete FAQ
								</Box>
								&nbsp;in the help center, or&nbsp;
								<Box
									component="a"
									href="mailto:sales@mangomap.com"
									sx={{ color: "inherit", textDecoration: "underline" }}>
									contact us
								</Box>
								&nbsp;directly.
							</Typography>
						</Stack>
					</Stack>
					<Stack spacing={2}>
						{faqs.map((faq) => (
							<Faq
								key={faq.id}
								{...faq}
							/>
						))}
					</Stack>
				</Stack>
			</Container>
		</Box>
	);
}

export interface FaqProps {
	answer: string;
	question: string;
}

function Faq({ answer, question }: FaqProps) {
	const [isExpanded, setIsExpanded] = React.useState<boolean>(false);

	return (
		<Card sx={{ p: 3 }}>
			<Stack
				onClick={() => {
					setIsExpanded((prevState) => !prevState);
				}}
				sx={{ cursor: "pointer" }}>
				<Stack
					direction="row"
					spacing={2}
					sx={{ alignItems: "center", justifyContent: "space-between" }}>
					<Typography variant="subtitle1">{question}</Typography>
					{isExpanded ? <CaretDown /> : <CaretRight />}
				</Stack>
				<Collapse in={isExpanded}>
					<Typography
						color="text.secondary"
						sx={{ pt: 3 }}
						variant="body2">
						{answer}
					</Typography>
				</Collapse>
			</Stack>
		</Card>
	);
}
